import { supabase } from '../lib/supabase';
import toast from 'react-hot-toast';

// 사용자가 차단되었는지 확인하는 함수
export async function checkIfUserBanned(phoneNumber?: string | null, instagramUsername?: string | null): Promise<boolean> {
  try {
    console.log('🔍 차단 확인 중...', { phoneNumber, instagramUsername });
    
    const { data, error } = await supabase.rpc('check_if_user_banned', {
      p_phone_number: phoneNumber || null,
      p_instagram_username: instagramUsername || null
    });

    if (error) {
      console.error('Error checking banned status:', error);
      return false;
    }

    console.log('🔍 차단 확인 결과:', data);
    return data || false;
  } catch (error) {
    console.error('Error in checkIfUserBanned:', error);
    return false;
  }
}

// 차단된 사용자의 데이터를 삭제하는 함수
export async function deleteBannedUserData(userId: string): Promise<void> {
  try {
    const { error } = await supabase.rpc('delete_banned_user_instagram_data', {
      p_user_id: userId
    });

    if (error) {
      console.error('Error deleting banned user data:', error);
    }
  } catch (error) {
    console.error('Error in deleteBannedUserData:', error);
  }
}

// 차단 메시지 표시 및 로그아웃 처리
export async function handleBannedUser(userId?: string): Promise<void> {
  // 5초 후에 차단 처리 실행
  setTimeout(async () => {
    // 데이터 삭제
    if (userId) {
      await deleteBannedUserData(userId);
    }

    // 토스트 메시지 표시
    toast.error('서버 업데이트가 진행 중입니다. 24시간 후 다시 시도하세요.', {
      duration: 5000,
      position: 'top-center',
      style: {
        background: '#ef4444',
        color: '#fff',
        fontWeight: 'bold',
        fontSize: '16px',
        padding: '16px',
        borderRadius: '8px',
      },
    });

    // 1초 후 로그아웃
    setTimeout(async () => {
      await supabase.auth.signOut();
      window.location.href = '/auth';
    }, 1000);
  }, 5000); // 5초 딜레이
}

// 인스타그램 연결 후 5초 뒤 차단 확인
export function checkBannedAfterInstagramConnect(
  phoneNumber?: string | null, 
  instagramUsername?: string | null,
  userId?: string
): void {
  setTimeout(async () => {
    const isBanned = await checkIfUserBanned(phoneNumber, instagramUsername);
    if (isBanned) {
      await handleBannedUser(userId);
    }
  }, 5000);
}